import {
    TextField,
    Button,
    MenuItem,
    Box,
    Card,
    CardContent,
    Grid,
    Checkbox,
    FormControlLabel,
    Snackbar,
    Alert
} from "@mui/material";


import { useState, useEffect } from "react";
import StoreSelector from "./StoreSelector";
import Logo from "./logo.png";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./CustomerForm.css";

function CustomerForm() {
    const [marital, setMarital] = useState("single");

    // captcha state
    const [captcha, setCaptcha] = useState({ key: "", image_url: "" });
    const [captchaValue, setCaptchaValue] = useState("");

    // Store
    const [selectedStore, setSelectedStore] = useState(null);

    // refer options
    const [referOptions, setReferOptions] = useState([]);
    const [referValue, setReferValue] = useState("");

    const [mobileError, setMobileError] = useState(false);
    const [whatsappError, setWhatsappError] = useState(false);

    const [toast, setToast] = useState({
        open: false,
        message: "",
        severity: "error",
    });
    
    // WhatsApp & Birthday state
    const [mobileValue, setMobileValue] = useState("");
    const [whatsappValue, setWhatsappValue] = useState("");
    const [autoFillWhatsApp, setAutoFillWhatsApp] = useState(false);
    const [birthdayDay, setBirthdayDay] = useState("");
    const [birthdayMonth, setBirthdayMonth] = useState("");
    const [anniversaryDay, setAnniversaryDay] = useState("");
    const [anniversaryMonth, setAnniversaryMonth] = useState("");
    const birthday_mmyy =
        birthdayMonth && birthdayDay
            ? `${String(birthdayDay).padStart(2, "0")}/${String(birthdayMonth).padStart(2, "0")}`
            : "";

        const anniversary_mmyy =
        anniversaryMonth && anniversaryDay
            ? `${String(anniversaryDay).padStart(2, "0")}/${String(anniversaryMonth).padStart(2, "0")}`
            : "";

    useEffect(() => {
        fetchCaptcha();
        fetch("https://hamarachoiceschemes.com/api/refer-through/")
        .then((res) => res.json())
        .then((data) => setReferOptions(data));
    }, []);

    // useEffect for autofill
    useEffect(() => {
    if (autoFillWhatsApp && mobileValue) {
        setWhatsappValue(mobileValue);
    }
    }, [mobileValue, autoFillWhatsApp]);

    const fetchCaptcha = async () => {
        const res = await fetch("https://hamarachoiceschemes.com/api/get-captcha/");
        const data = await res.json();
        setCaptcha(data);
        setCaptchaValue("");
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
            // alert("Please enter captcha");
            setToast({
                open: true,
                message: "Please enter Captcha",
                severity: "warning",
            });
            return;
        }

        if (!referValue) {
            // alert("Please select Referred By");
            setToast({
                open: true,
                message: "Please select Referred By",
                severity: "warning",
            });
            return;
        }

        const data = {
            name: e.target.name.value,
            mobile: e.target.mobile.value,
            whatsapp: e.target.whatsapp.value,
            birthday_mmyy: birthday_mmyy,
            marital_status: marital,
            spouse_name: e.target.spouse?.value || "",
            anniversary_mmyy: anniversary_mmyy,
            refer_through: e.target.refer.value,
            location: e.target.location.value,
            address: e.target.address.value,
            store: selectedStore?.id, // <--- store the selected store ID
            captcha_key: captcha.key,
            captcha_value: captchaValue,
        };

        const res = await fetch("https://hamarachoiceschemes.com/api/customer-survey/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (res.ok) {
            // alert("Saved successfully 🎉");
            setToast({
                open: true,
                message: "Saved successfully 🎉",
                severity: "success",
            });
            fetchCaptcha();
            e.target.reset();
            setMarital("single");
            setMobileValue("");
            setWhatsappValue("");
            setAutoFillWhatsApp(false);

            setBirthdayDay("");
            setBirthdayMonth("");
            setAnniversaryDay("");
            setAnniversaryMonth("");
            setReferValue("")
        } else {
            // alert("Error, please check captcha or fields!");
            setToast({
                open: true,
                message: "Error, please check captcha or fields!",
                severity: "warning",
            });
            fetchCaptcha();
        }
    };

    return (
        <Box className="page-bg">
            <Grid container justifyContent="center"
            >
                <Grid>
                <Card className="form-card">
                    <CardContent>
                        {/* Logo */}
                        <Box className="logo-box">
                            <img src={Logo} alt="Brand Logo" />
                        </Box>

                        <StoreSelector
                            value={selectedStore}
                            onChange={(store) => setSelectedStore(store)}
                        />

                        <form onSubmit={submitForm}>
                            {/* Name & Mobile */}
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 12, md: 12 }} mb={1}>
                                    <TextField
                                    name="name"
                                    label="Full Name"
                                    fullWidth
                                    required
                                    className="input-bg"
                                    slotProps={{
                                        inputLabel: {
                                        sx: {
                                            "& .MuiFormLabel-asterisk": {
                                            color: "red",
                                            fontWeight: "bold",
                                            },
                                        },
                                        },
                                    }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6 }} mb={1}>
                                    <TextField
                                        name="mobile"
                                        label="Mobile Number"
                                        fullWidth
                                        required
                                        className="input-bg"
                                        type="tel"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxLength={10}
                                        value={mobileValue}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");

                                            // enforce max 10 digits
                                            if (value.length > 10) return;

                                            setMobileValue(value);

                                            // error if less than 10 digits (only after typing starts)
                                            setMobileError(value.length > 0 && value.length < 10);

                                            if (autoFillWhatsApp && !whatsappValue) {
                                                setWhatsappValue(value);
                                            }
                                        }}
                                        error={mobileError}
                                        helperText={mobileError ? "Mobile number must be 10 digits" : ""}
                                        slotProps={{
                                            inputLabel: {
                                            sx: {
                                                "& .MuiFormLabel-asterisk": {
                                                color: "red",
                                                fontWeight: "bold",
                                                },
                                            },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6 }} mb={1}>
                                    <TextField
                                    name="whatsapp"
                                    label="WhatsApp Number"
                                    fullWidth
                                    className="input-bg whatsapp"
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    maxLength={10}
                                    value={whatsappValue}
                                    onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");

                                            // enforce max 10 digits
                                            if (value.length > 10) return;

                                            setWhatsappValue(e.target.value)

                                             // error if less than 10 digits (only after typing starts)
                                            setWhatsappError(value.length > 0 && value.length < 10);
                                        }}
                                        error={whatsappError}
                                        helperText={whatsappError ? "Mobile number must be 10 digits" : ""}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={autoFillWhatsApp}
                                                onChange={(e) => {
                                                    setAutoFillWhatsApp(e.target.checked);
                                                    if (e.target.checked && mobileValue && !whatsappValue) {
                                                        // fill WhatsApp immediately when checked
                                                        setWhatsappValue(mobileValue);
                                                    }
                                                }}
                                                size="small"
                                            />
                                        }
                                        label="Autofill WhatsApp"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                            fontSize: "0.8rem",   // smaller label text
                                            color: "#000",         // optional: change color
                                            },
                                            marginTop: 0,
                                            marginLeft: 0,
                                        }}
                                    />

                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Grid container spacing={1}>
                                        {/* Birthday Day */}
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                            <TextField
                                                select
                                                label="Birth Day"
                                                fullWidth
                                                className="input-bg"
                                                value={birthdayDay}
                                                onChange={(e) => setBirthdayDay(e.target.value)}
                                            >
                                                {[...Array(31)].map((_, i) => (
                                                <MenuItem key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* Birthday Month */}
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                            <TextField
                                                select
                                                label="Birth Month"
                                                fullWidth
                                                className="input-bg"
                                                value={birthdayMonth}
                                                onChange={(e) => setBirthdayMonth(e.target.value)}
                                            >
                                                {[
                                                "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"
                                                ].map((month, i) => (
                                                <MenuItem key={i + 1} value={i + 1}>
                                                    {month}
                                                </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* Marital Status */}
                                        <Grid size={{ xs: 12, sm: 12, md: 4 }} mb={2}>
                                        <Box>
                                        <TextField
                                            select
                                            label="Marital Status"
                                            fullWidth
                                            value={marital}
                                            onChange={(e) => setMarital(e.target.value)}
                                            className="input-bg"
                                        >
                                            <MenuItem value="single">Single</MenuItem>
                                            <MenuItem value="married">Married</MenuItem>
                                        </TextField>
                                        </Box>
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>

                            {/* Spouse Details */}
                            {marital === "married" && (
                            <Grid container spacing={2} mt={1}>
                                <Grid size={{ xs: 12, sm: 12, md: 4 }} mb={2}>
                                    <TextField
                                        name="spouse"
                                        label="Spouse Name"
                                        fullWidth
                                        className="input-bg"
                                    />
                                </Grid>

                                {/* Anniversary Day */}
                                <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                    <TextField
                                        select
                                        label="Anniv Day"
                                        fullWidth
                                        className="input-bg"
                                        value={anniversaryDay}
                                        onChange={(e) => setAnniversaryDay(e.target.value)}
                                    >
                                        {[...Array(31)].map((_, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                {/* Anniversary Month */}
                                <Grid size={{ xs: 6, sm: 6, md: 4 }} mb={2}>
                                    <TextField
                                        select
                                        label="Anniv Month"
                                        fullWidth
                                        className="input-bg"
                                        value={anniversaryMonth}
                                        onChange={(e) => setAnniversaryMonth(e.target.value)}
                                    >
                                        {[
                                        "Jan","Feb","Mar","Apr","May","Jun",
                                        "Jul","Aug","Sep","Oct","Nov","Dec"
                                        ].map((month, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {month}
                                        </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                            </Grid>

                            )}

                            {/* Refer Through */}
                            <Box mb={2}>
                                <TextField
                                    select
                                    name="refer"
                                    label="Referred By"
                                    fullWidth
                                    required
                                    className="input-bg"
                                    value={referValue || ""}
                                    onChange={(e) => setReferValue(e.target.value)}
                                >
                                    {/* Placeholder */}
                                    <MenuItem value="" disabled>
                                    Select option
                                    </MenuItem>

                                    {referOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                    ))}
                                </TextField>
                            </Box>

                            {/* Location & Address */}
                            <Grid container spacing={2} mb={3}>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                <TextField
                                name="location"
                                label="Location"
                                fullWidth
                                className="input-bg"
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                <TextField
                                name="address"
                                label="Address"
                                fullWidth
                                className="input-bg"
                                />
                            </Grid>
                            </Grid>

                            {/* Captcha */}
                            <Box className="captcha-box" mt={5} mb={4}>
                            {captcha.image_url && (
                                <Grid container spacing={1} alignItems="center">
                                {/* Captcha Image */}
                                <Grid size={{ xs: 4 }}>
                                    <img
                                    src={captcha.image_url}
                                    alt="captcha"
                                    style={{ width: "100%", height: "40px", objectFit: "contain" }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 6 }}>
                                    <TextField
                                        label="Captcha"
                                        fullWidth
                                        className="input-bg"
                                        value={captchaValue}
                                        onChange={(e) => setCaptchaValue(e.target.value.toUpperCase())}
                                    />
                                </Grid>


                                {/* Refresh Button */}
                                <Grid size={{ xs: 2 }}>
                                    <Button
                                    size="small"
                                    fullWidth
                                    className="refresh-btn"
                                    onClick={fetchCaptcha}
                                    >
                                    <RefreshIcon fontSize="small" />
                                    </Button>
                                </Grid>
                                </Grid>
                            )}
                            </Box>

                            {/* Submit */}
                            <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className="submit-btn"
                            >
                            Submit
                            </Button>
                        </form>
                    </CardContent>
                </Card>
                </Grid>
            </Grid>
            <Snackbar
                open={toast.open}
                autoHideDuration={3000}
                onClose={() => setToast({ ...toast, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    severity={toast.severity}
                    onClose={() => setToast({ ...toast, open: false })}
                >
                    {toast.message}
                </Alert>
            </Snackbar>

        </Box>
    );
}

export default CustomerForm;
